import { Component } from '@angular/core';
import { IxFilterStringSimpleComponent, IxNgComponentsModule } from 'ix-ng-components';
import { VpoFilterHeaderComponent } from '../header/vpo-filter-header.component';

@Component({
  selector: 'lib-filter-string',
  templateUrl: './vpo-filter-string.component.html',
  styleUrls: ['./vpo-filter-string.component.scss'],
  imports: [VpoFilterHeaderComponent, IxNgComponentsModule],
})
export class VpoFilterStringComponent extends IxFilterStringSimpleComponent {}
